// extracted by mini-css-extract-plugin
export default {"login":"qyWzd9L8","_hidden":"zDw6Mis4","desktop":"desktop","mobile":"mobile"};